import { useCheckoutConfiguration, useCheckoutConsentReminder } from "@jti/commerce";
import { useUserConsents } from "@jti/rest-api";

import { useAppModel } from "../../contexts/AppModelContext/AppModelContext";

export const useConsentPopUp = (shouldUseAEMConfig: boolean = false) => {
  const { consentReminderPopup: aemConfig } = useAppModel();
  const { consentReminderPopup: checkoutConfig } = useCheckoutConfiguration();

  const consentReminderPopup = shouldUseAEMConfig ? aemConfig : checkoutConfig;

  const consentsQuery = useUserConsents("all");
  return useCheckoutConsentReminder(
    { ...consentReminderPopup, enabled: consentReminderPopup?.consentReminderPopupEnabled },
    consentsQuery
  );
};
